






































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Emittery from 'emittery';

import { Busy } from '@/components/Busy.ts';

import { EventForWidget } from '@/modules/events/components/EventsWidget/models';
import { eventsModuleName } from '@/modules/events/store/index';
import { Actions } from '@/modules/events/store/actions';
import { Getters } from '@/modules/events/store/getters';
import { getEmittery } from '@/core/emittery';
import { getAuthService } from '@/auth';
import Notify from '@/shared/services/Notify/Notify';
const eventsModule = namespace(eventsModuleName);

@Component({
  components: {
  },
})
export default class EventsWidget extends Vue {

  private busy: Busy = new Busy();
  private emitter: Emittery = getEmittery();
  private auth = getAuthService();

  @eventsModule.Getter(Getters.EVENTS_FOR_WIDGET) private events!: EventForWidget[];
  @eventsModule.Action(Actions.FETCH_EVENTS_FOR_WIDGET) private fetchEventsForWidget!: any;
  @eventsModule.Action(Actions.UPDATE_PRESENCE) private updatePresence!: any;

  public async created() {
    this.emitter.on('authorization-loaded', async (isAuthenticated) => {
      await this.fetchEvents();
    });
  }

  private async fetchEvents() {
    this.busy.SetBusy();
    await this.fetchEventsForWidget();
    this.busy.SetFree();
  }

  get isBusyOrLoading() {
    return this.busy.isBusy || this.auth.loading;
  }

  private async submitAnswer(event: EventForWidget) {
    await this.updatePresence(event);
  }

  get anyEvents() {
    return this.events && this.events.length > 0;
  }

}
